import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiUrls } from '../../../config/api-urls/api-urls';
import { MainService } from '../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-notification',
  templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnInit {

  form: FormGroup | any;
  therapistList: any = [];
  notificationData: any = [];
  currentPage: any = 1;
  patientList: any = [];
  patientListData: any = [];
  userType: any;
  total: any;
  itemPerPage: any = 10;

  constructor(public service: MainService) { }

  ngOnInit() {
    this.form = new FormGroup({
      notification: new FormControl('', Validators.required),
      patNotification: new FormControl('Therapists'),
      search: new FormControl('')
    });
    this.form.valueChanges.subscribe((res: any) => {
      this.userType = res.patNotification;

      setTimeout(() => {
        this.patientListApii()
      }, 1000);
    })

    this.getNotificationList();
  }

  selectUser(id: any) {
    this.patientList = [];
    this.patientList.push(id)
  }

  pagination(page: any) {
    this.currentPage = page;
    this.getNotificationList();

  }

  // getNotificationList integration
  getNotificationList() {
    this.service.getApi(ApiUrls.notification_list + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.total = res.paginationData.total;
        this.notificationData = res.result ? res.result : [];
      } else {
        this.notificationData = res.result ? res.result : [];
      }
    })
  }

  sendNotification() {
    const data = {
      users: this.patientList,
      message: this.form.value.notification
    }
    this.service.showSpinner();
    this.service.postApi(ApiUrls.sendNotification, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.service.hideSpinner();
        this.service.successToast('Notification sent successfully')
        this.form.controls.notification.reset()
        this.getNotificationList();
      }
    })

  }

  // Patient list api integration 
  PatientListApi() {
    setTimeout(() => {
      this.patientListApii();
    }, 1000);

  }

  patientListApii() {
    let userType;

    if (this.userType == 'Therapists') {
      userType = "THERAPIST";

    }
    else if (this.userType == 'Patients') {
      userType = "USER";
    }

    this.service.showSpinner()
    this.service.getApi(ApiUrls.userList + `?search=${this.form.value.search}&userType=${userType}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.patientListData = res.result;
        this.patientList = []
        res.result.forEach((ele: any) => {
          this.patientList.push(ele._id)
        });
        this.service.hideSpinner();
      }
      else {
        this.service.hideSpinner();
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }



}
